// API Client abstraction layer - hiding backend implementation details
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../integrations/supabase/types';
import { fetchWithSession } from './app-session';

// Environment variables with generic names
const API_BASE_URL = "https://otpsppvalhuqnixyzlmd.supabase.co";
const API_PUBLIC_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im90cHNwcHZhbGh1cW5peHl6bG1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkxODU3ODEsImV4cCI6MjA2NDc2MTc4MX0.W2J19rcOmPacKhg1u221Gqmcr9ffca95rJktluy2SUw";

// Create the backend client with generic naming
// Every database request carries the caller's session token (see app-session.ts).
const backendClient = createClient<Database>(API_BASE_URL, API_PUBLIC_KEY, {
  global: { fetch: fetchWithSession },
});

// Export with generic names
export const apiClient = backendClient;
export const dbClient = backendClient;
export const storageClient = backendClient.storage;
export const authClient = backendClient.auth;
export const functionsClient = backendClient.functions;

// Legacy support - to maintain compatibility during transition
export const supabase = backendClient;

// Export types for convenience
export type { Database };